import { render, staticRenderFns } from "./mandato.vue?vue&type=template&id=2d359e90"
import script from "./mandato.vue?vue&type=script&lang=js"
export * from "./mandato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports